import { motion } from "framer-motion";
import { clinicConfig } from "@/config/clinic";
import { fadeUp, viewport } from "@/lib/reveal";

const DOCTOR_IMG =
  "https://images.unsplash.com/photo-1758691461516-7e716e0ca135?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxmcmllbmRseSUyMHNlbmlvciUyMGRvY3RvciUyMGZhbWlseSUyMG1lZGljaW5lJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgzOTc1Mjg1fDA&ixlib=rb-4.1.0&q=85";

const STATS = [
  { value: clinicConfig.experienceYears, label: "Years in practice" },
  { value: "1", label: "Trusted local physician" },
  { value: "24h", label: "Doc Talk response window" },
];

export const DoctorProfile = () => {
  return (
    <section id="doctor" data-testid="doctor-section" className="bg-primary py-24 text-primary-foreground md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 md:px-12 lg:grid-cols-12 lg:gap-16">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="lg:col-span-5"
        >
          <div className="relative">
            <div className="absolute -inset-3 border border-primary-foreground/20" aria-hidden />
            <img
              src={DOCTOR_IMG}
              alt="Dr. Andres Rago, family medicine physician"
              data-testid="doctor-image"
              className="relative aspect-[4/5] w-full object-cover grayscale-[0.15]"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-primary/85 p-4 backdrop-blur-sm">
              <p className="font-serif text-xl font-medium">{clinicConfig.doctor}</p>
              <p className="text-sm text-primary-foreground/70">{clinicConfig.doctorTitle}</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="lg:col-span-7"
        >
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.24em] text-accent">
            The physician
          </p>
          <h2 className="font-serif text-4xl font-medium leading-tight tracking-tight md:text-5xl">
            Over three decades of caring for this community.
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-primary-foreground/85">
            {clinicConfig.doctor} brings over 30 years of experience caring for
            patients across southern West Virginia. His practice is built on
            steady, personal relationships — the kind of primary care where your
            doctor knows your history and your family.
          </p>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-primary-foreground/85">
            That same continuity now extends online through Doc Talk, so
            established care stays with you whether you're in the office or at home.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-primary-foreground/15 pt-8">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`doctor-stat-${s.label}`}>
                <p className="font-serif text-4xl font-medium text-accent md:text-5xl">{s.value}</p>
                <p className="mt-1 text-sm text-primary-foreground/70">{s.label}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DoctorProfile;
